/* ──────────────────────────────
   src/components/User/UserTable.jsx
   ────────────────────────────── */
   import React, { useEffect, useState } from "react";

   /* ─── libs ──────────────────────────────────────────── */
   import dayjs   from "dayjs";
   import $       from "jquery";
   import axios   from "axios";
   
   /* ─── redux ─────────────────────────────────────────── */
   import { connect, useDispatch, useSelector } from "react-redux";
   import {
     getUser,
     handleBlockUnblockSwitch,
     assignBadge,
   } from "../../store/user/action";
   
   /* ─── routing ───────────────────────────────────────── */
   import { Link, useNavigate } from "react-router-dom";
   
   /* ─── UI / assets ───────────────────────────────────── */
   import { Tooltip }      from "@mui/material";
   import ExpandMoreIcon   from "@mui/icons-material/ExpandMore";
   import Male             from "../../assets/images/male.png";
   import Pagination       from "../../pages/Pagination";
   
   /* ─── date-range picker ─────────────────────────────── */
   import { DateRangePicker } from "react-date-range";
   import "react-date-range/dist/styles.css";
   import "react-date-range/dist/theme/default.css";
   
   const UserTable = (props) => {
     const dispatch = useDispatch();
     const navigate = useNavigate();
   
     /* ── paging / filters ─────────────────────────────── */
     const [data, setData]               = useState([]);
     const [activePage, setActivePage]   = useState(1);
     const [rowsPerPage, setRowsPerPage] = useState(10);
     const [search, setSearch]           = useState("ALL");
   
     /* calendar */
     const today     = new Date();
     const [date, setDate] = useState([
       {
         startDate : new Date(today.getFullYear(), today.getMonth(), 1),
         endDate   : new Date(today.getFullYear(), today.getMonth() + 1, 0),
         key       : "selection",
       },
     ]);
     const [sDate, setsDate] = useState(dayjs().startOf("month").format("YYYY/M/DD"));
     const [eDate, seteDate] = useState(dayjs().endOf("month").format("YYYY/M/DD"));
   
     const formattedStart = sDate === "ALL" ? "ALL" : dayjs(sDate).format("YYYY/M/DD");
     const formattedEnd   = eDate === "ALL" ? "ALL" : dayjs(eDate).format("YYYY/M/DD");
   
     /* ── badge state ─────────────────────────────────── */
     const [badgeModalOpen, setBadgeModalOpen] = useState(false);
     const [badgeList, setBadgeList]           = useState([]);
     const [badgeMap , setBadgeMap]            = useState({});   // { id: image }
     const [selectedUser,  setSelectedUser]    = useState(null);
     const [selectedBadge, setSelectedBadge]   = useState("null");
   
     /* fetch all badges once (id → image map) */
     useEffect(() => {
       axios.get("badge/badges").then(({ data }) => {
         if (!data.status) return;
         setBadgeList(data.badges);
   
         const map = {};
         data.badges.forEach((b) => {
           map[b._id.toString()] = b.image;
         });
         setBadgeMap(map);
       });
     }, []);
   
     /* ── fetch users whenever filters change ──────────── */
     useEffect(() => {
       dispatch(
         getUser(activePage, rowsPerPage, search, formattedStart, formattedEnd)
       );
     }, [dispatch, activePage, rowsPerPage, search, formattedStart, formattedEnd]);
   
     const { user, activeUser, male, female, totalUser } = useSelector(
       (state) => state.user
     );
     useEffect(() => setData(user), [user]);
   
     /* fallback user images */
     useEffect(() => {
       $("img").on("error", function () {
         $(this).attr("src", Male);
       });
     }, []);
   
     /* ── badge helpers ───────────────────────────────── */
     const openBadgeModal = (u) => {
       setSelectedUser(u);
       setSelectedBadge("null");
       setBadgeModalOpen(true);
     };
   
     const saveBadge = () => {
       if (!selectedUser || selectedBadge === "null") return;
   
       props
         .assignBadge({
           userId : selectedUser._id,
           badgeId: selectedBadge,
           action : "add",
         })
         .then(() =>
           dispatch(
             getUser(
               activePage,
               rowsPerPage,
               search,
               formattedStart,
               formattedEnd
             )
           )
         );
   
       setBadgeModalOpen(false);
     };
   
     /* helper that always returns a valid badge image */
     const getBadgeImg = (badgeItem) => {
       // new populated shape → object with .image
       if (badgeItem?.badge && typeof badgeItem.badge === "object") {
         return badgeItem.badge.image ?? "";
       }
       // new non-populated shape → ObjectId in badgeItem.badge
       if (badgeMap[badgeItem.badge?.toString?.()]) {
         return badgeMap[badgeItem.badge.toString()];
       }
       // very old schema fallback
       return badgeItem.image || "";
     };
   
     /* ── misc controls ───────────────────────────────── */
     const handlePageChange = (p) => setActivePage(p);
     const handleRowsChange = (v) => {
       setActivePage(1);
       setRowsPerPage(v);
     };
     const blockToggle = (id) => props.handleBlockUnblockSwitch(id);
   
     const info    = (u) => { sessionStorage.setItem("user", JSON.stringify(u)); navigate("/admin/user/detail"); };
     const history = (u) => { sessionStorage.setItem("user", JSON.stringify(u)); navigate("/admin/user/history"); };
   
     const resetFilter = () => {
       setActivePage(1);
       setRowsPerPage(10);
       setsDate("ALL");
       seteDate("ALL");
       $("#datePicker").hide();
       dispatch(getUser(1, 10, "ALL", "ALL", "ALL"));
     };
   
     const applyDateFilter = () => {
       setActivePage(1);
       $("#datePicker").hide();
       dispatch(getUser(1, rowsPerPage, search, formattedStart, formattedEnd));
     };
   
     const toggleDatePicker = () => $("#datePicker").toggle();
   
     /* ── JSX ─────────────────────────────────────────── */
     return (
       <>
         {/* ───── header / breadcrumb ───── */}
         <div className="page-title">
           <div className="row">
             <div className="col-12 col-md-6 order-md-1 order-last">
               <h3 className="mb-3 text-light">User</h3>
             </div>
   
             <div className="col-12 col-md-6 order-md-2 order-first">
               <nav aria-label="breadcrumb" className="breadcrumb-header float-start float-lg-end">
                 <ol className="breadcrumb">
                   <li className="breadcrumb-item">
                     <Link to="/admin/dashboard" className="text-danger">
                       Dashboard
                     </Link>
                   </li>
                   <li className="breadcrumb-item active" aria-current="page">
                     User
                   </li>
                 </ol>
               </nav>
             </div>
           </div>
         </div>
   
         {/* ───── stats cards ───── */}
         <div className="row">
           <div className="col-lg-12">
             <div className="row">
               {/* male */}
               <div className="col-lg-4">
                 <div className="card stats-card">
                   <div className="card-body">
                     <div className="stats-info">
                       <h5 className="card-title">{male || 0}</h5>
                       <p className="stats-text">Male</p>
                     </div>
                     <div className="stats-icon change-danger">
                       <i className="material-icons">male</i>
                     </div>
                   </div>
                 </div>
               </div>
   
               {/* female */}
               <div className="col-lg-4">
                 <div className="card stats-card">
                   <div className="card-body">
                     <div className="stats-info">
                       <h5 className="card-title">{female || 0}</h5>
                       <p className="stats-text">Female</p>
                     </div>
                     <div className="stats-icon change-success">
                       <i className="material-icons">female</i>
                     </div>
                   </div>
                 </div>
               </div>
   
               {/* active */}
               <div className="col-lg-4">
                 <div className="card stats-card">
                   <div className="card-body">
                     <div className="stats-info">
                       <h5 className="card-title">{activeUser}</h5>
                       <p className="stats-text">Total Active User</p>
                     </div>
                     <div className="stats-icon change-pink">
                       <i className="material-icons">people</i>
                     </div>
                   </div>
                 </div>
               </div>
             </div>
           </div>
         </div>
   
         {/* ───── table card ───── */}
         <div className="row">
           <div className="col">
             <div className="card" id="card">
               {/* filters */}
               <div className="card-header pb-0">
                 <div className="row my-3">
                   <div className="col-md-8 d-flex align-items-center">
                     <button className="btn btn-info me-2" onClick={resetFilter}>
                       All
                     </button>
   
                     <button className="btn btn-info" onClick={toggleDatePicker}>
                       Analytics <ExpandMoreIcon />
                     </button>
   
                     {formattedStart !== "ALL" && (
                       <p className="my-2 ms-3">
                         {formattedStart} to {formattedEnd}
                       </p>
                     )}
                   </div>
   
                   {/* search bar */}
                   <div className="col-md-4">
                     <div className="input-group mb-3 border rounded-pill">
                       <input
                         id="searchBar"
                         type="search"
                         className="form-control bg-none border-0 rounded-pill"
                         placeholder="What're you searching for?"
                         autoComplete="off"
                         onChange={(e) => setSearch(e.target.value)}
                         onKeyPress={(e) => {
                           if (e.key === "Enter") {
                             e.preventDefault();
                             dispatch(
                               getUser(1, rowsPerPage, search, formattedStart, formattedEnd)
                             );
                             setActivePage(1);
                           }
                         }}
                       />
   
                       <button
                         className="btn text-danger border-0"
                         onClick={() => {
                           setSearch(document.getElementById("searchBar").value);
                           setActivePage(1);
                         }}
                       >
                         <i className="fas fa-search" />
                       </button>
                     </div>
                   </div>
   
                   {/* date-picker collapse */}
                   <div
                     id="datePicker"
                     className="date-picker-wrapper mt-5 pt-5"
                     style={{ display: "none" }}
                   >
                     <div className="container table-responsive">
                       <DateRangePicker
                         maxDate={today}
                         ranges={date}
                         showSelectionPreview
                         moveRangeOnFirstSelection={false}
                         direction="horizontal"
                         onChange={(item) => {
                           setDate([item.selection]);
                           setsDate(dayjs(item.selection.startDate).format("YYYY/M/DD"));
                           seteDate(dayjs(item.selection.endDate).format("YYYY/M/DD"));
                         }}
                       />
                       <button className="btn btn-danger mt-3" onClick={applyDateFilter}>
                         Apply Filter
                       </button>
                     </div>
                   </div>
                 </div>
               </div>
   
               {/* table */}
               <div className="card-body card-overflow pt-0">
                 <table className="table table-striped mt-5 text-center">
                   <thead>
                     <tr>
                       <th>No.</th>
                       <th>Image</th>
                       <th>Badge</th>
                       <th>Name</th>
                       <th>UniqueId</th>
                       <th>Gender</th>
                       <th>RCoin</th>
                       <th>Country</th>
                       <th>Level</th>
                       <th>isBlock</th>
                       <th>isHost</th>
                       <th>Agency</th>
                       <th>Info</th>
                       <th>History</th>
                     </tr>
                   </thead>
   
                   <tbody>
                     {data.length ? (
                       data.map((u, i) => (
                         <tr key={u._id}>
                           <td>{(activePage - 1) * rowsPerPage + i + 1}</td>
   
                           {/* user image */}
                           <td>
                             <img
                               src={u.image || Male}
                               alt="user"
                               height="50"
                               width="50"
                               style={{
                                 objectFit   : "cover",
                                 borderRadius: 10,
                                 border      : "2px solid #fff",
                               }}
                             />
                           </td>
   
                           {/* badges */}
                           <td style={{ minWidth: 120 }}>
                             {u.badges?.length
                               ? u.badges.map((b) => {
                                const imgSrc = getBadgeImg(b); /* ← no “|| Male” fallback          */
                                if (!imgSrc) return null
                                   return (
                                     <img
                                       key={b.badge?._id ?? b.badge}
                                       src={imgSrc}
                                       alt="badge"
                                       height="28"
                                       width="28"
                                       title={b.name}
                                       className="me-1 mb-1 rounded"
                                       style={{
                                         objectFit: "cover",
                                         cursor   : "pointer",
                                       }}
                                       onClick={() =>
                                         props.assignBadge({
                                           userId : u._id,
                                           badgeId: b.badge?._id ?? b.badge,
                                           action : "remove",
                                         })
                                       }
                                     />
                                   );
                                 })
                               : "-"}
                             <button
                               className="btn btn-xs btn-outline-primary d-block mt-1"
                               onClick={() => openBadgeModal(u)}
                             >
                               Add
                             </button>
                           </td>
   
                           <td>{u.name || "-"}</td>
                           <td>{u.uniqueId || "-"}</td>
                           <td>{u.gender || "-"}</td>
                           <td className="text-danger">{u.rCoin || 0}</td>
                           <td className="text-success">{u.country || "-"}</td>
                           <td className="text-warning">{u.level?.name || "-"}</td>
   
                           {/* block switch */}
                           <td>
                             <label className="switch">
                               <input
                                 type="checkbox"
                                 checked={u.isBlock}
                                 onChange={() => blockToggle(u._id)}
                               />
                               <span className="slider">
                                 <p
                                   style={{
                                     fontSize : 12,
                                     marginLeft: u.isBlock ? "-24px" : "35px",
                                     marginTop: 6,
                                     color    : "#000",
                                   }}
                                 >
                                   {u.isBlock ? "Yes" : "No"}
                                 </p>
                               </span>
                             </label>
                           </td>
   
                           <td>{u.isHost ? "Yes" : "No"}</td>
                           <td>{u.isHost ? u.agency?.name : "---"}</td>
   
                           <td>
                             <Tooltip title="Info">
                               <button
                                 className="btn btn-sm btn-info"
                                 onClick={() => info(u)}
                               >
                                 <i className="fas fa-info-circle" />
                               </button>
                             </Tooltip>
                           </td>
   
                           <td>
                             <Tooltip title="History">
                               <button
                                 className="btn btn-sm btn-success"
                                 onClick={() => history(u)}
                               >
                                 <i className="fas fa-history" />
                               </button>
                             </Tooltip>
                           </td>
                         </tr>
                       ))
                     ) : (
                       <tr>
                         <td colSpan="14" align="center">
                           Nothing to show!!
                         </td>
                       </tr>
                     )}
                   </tbody>
                 </table>
   
                 {/* pagination */}
                 <Pagination
                   activePage={activePage}
                   rowsPerPage={rowsPerPage}
                   userTotal={totalUser}
                   handleRowsPerPage={handleRowsChange}
                   handlePageChange={handlePageChange}
                 />
               </div>
             </div>
           </div>
         </div>
   
         {/* ───── badge modal ───── */}
         {badgeModalOpen && (
           <div className="modal fade show d-block" tabIndex="-1">
             <div className="modal-dialog">
               <div className="modal-content">
                 <div className="modal-header">
                   <h5 className="modal-title">
                     {selectedUser?.name} – Add badge
                   </h5>
                   <button
                     className="btn-close"
                     onClick={() => setBadgeModalOpen(false)}
                   />
                 </div>
   
                 <div className="modal-body">
                   <select
                     className="form-select"
                     value={selectedBadge}
                     onChange={(e) => setSelectedBadge(e.target.value)}
                   >
                     <option value="null">Choose badge…</option>
                     {badgeList.map((b) => (
                       <option key={b._id} value={b._id}>
                         {b.name}
                       </option>
                     ))}
                   </select>
                 </div>
   
                 <div className="modal-footer">
                   <button
                     className="btn btn-secondary"
                     onClick={() => setBadgeModalOpen(false)}
                   >
                     Cancel
                   </button>
                   <button
                     className="btn btn-primary"
                     disabled={selectedBadge === "null"}
                     onClick={saveBadge}
                   >
                     Save
                   </button>
                 </div>
               </div>
             </div>
           </div>
         )}
       </>
     );
   };
   
   export default connect(null, {
     getUser,
     handleBlockUnblockSwitch,
     assignBadge,
   })(UserTable);
   